/** Real-time notification resource Type.  */
export enum RealTimeNotificationResourceType {
    /** The Appointment Resource Type. */
    Appointment,
    /** The Call Center Resource Type. */
    CallCenter
}
